import { computed, defineComponent } from "vue";

export default defineComponent({
  props: {
    backgroundColor: { type: String, required: false },
    revealOnScroll: { type: Boolean, default: false },
  },

  setup(props) {
    const sectionClasses = computed(() => {
      let classes = "";

      if (props.backgroundColor) {
        classes += `section--on-backgroundcolor section--${props.backgroundColor}`;
      }

      return classes;
    });

    return { sectionClasses };
  },
});
